import { ToitEnPenteLayers } from "@iko-design-center/shared"
import { MultiSelectOption } from "../../components/common/MultiSelect"

export type DownloadState = {
  technicalFiche: {
    toitInsulation: boolean
  }
  DOP: {
    toitInsulation: boolean
  }
  thermalCalculation: boolean
  specifications: boolean
  BIMFile: boolean
  screenshots: boolean
  processingGuideline: boolean
}

export const initialDownloadState: DownloadState = {
  technicalFiche: {
    toitInsulation: false,
  },
  DOP: {
    toitInsulation: false,
  },
  thermalCalculation: false,
  specifications: false,
  BIMFile: false,
  screenshots: false,
  processingGuideline: false,
}

export const allSelectedDownloadState: DownloadState = {
  technicalFiche: {
    toitInsulation: true,
  },
  DOP: {
    toitInsulation: true,
  },
  thermalCalculation: true,
  specifications: true,
  BIMFile: true,
  screenshots: true,
  processingGuideline: true,
}

export type LayerState = {
  [key in ToitEnPenteLayers]: boolean
}

export function getLayerOptions({
  t,
  state,
}: {
  t: any
  state: LayerState
}): MultiSelectOption<ToitEnPenteLayers>[] {
  return [
    {
      label: t("modal.download.insulation"),
      value: ToitEnPenteLayers.toitInsulation,
      checked: state.toitInsulation,
    },
  ]
}
